import Vue from "vue";
class GeolocationService {

  GetCoordinates(filter) {
    return Vue.prototype.$http({
      url: "/geolocation/get",
      data: filter,
      method: "POST"
    });
  }

  ReportTable(filter) {
    return Vue.prototype.$http({
      url: "/geolocation/report/table",
      data: filter,
      method: "POST"
    });
  }

  
}

export default new GeolocationService();
